import QuestionIcon from './QuestionIcon';
export default QuestionIcon;
